/* Kanal-Reiter für «Neu auf …» (snippets/pg-social-feed.liquid).
   Ohne dieses Skript bleiben alle Reihen untereinander sichtbar. */
(function () {
  'use strict';
  function enhance(root) {
    if (root.dataset.pgSocialFeedReady) return;
    var tablist = root.querySelector('[role="tablist"]');
    if (!tablist) return;
    var tabs = Array.prototype.slice.call(tablist.querySelectorAll('[role="tab"]'));
    if (tabs.length < 2) return;
    root.dataset.pgSocialFeedReady = 'true';

    function panelFor(tab) { return document.getElementById(tab.getAttribute('aria-controls')); }
    tabs.forEach(function (tab) {
      var panel = panelFor(tab);
      if (!panel) return;
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', tab.id);
    });

    function select(tab, focus) {
      tabs.forEach(function (other) {
        var on = other === tab;
        other.setAttribute('aria-selected', on ? 'true' : 'false');
        other.tabIndex = on ? 0 : -1;
        var panel = panelFor(other);
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () { select(tab, false); });
      tab.addEventListener('keydown', function (event) {
        var next = null;
        if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
        else if (event.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length];
        else if (event.key === 'Home') next = tabs[0];
        else if (event.key === 'End') next = tabs[tabs.length - 1];
        if (next) { event.preventDefault(); select(next, true); }
      });
    });

    tablist.hidden = false;
    root.classList.add('is-enhanced');
    select(tabs[0], false);
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-pg-social-feed]'), enhance);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
